import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { API, LOGO_URL } from "../lib/constants";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("chh_admin_token", res.data.token);
      localStorage.setItem("chh_admin_email", res.data.email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-[#0B192C] px-4"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-2xl shadow-2xl p-8">
        <div className="flex flex-col items-center text-center">
          <img
            src={LOGO_URL}
            alt="Car Hurt Help"
            className="h-16 w-16 rounded-lg object-cover bg-[#0B192C]"
          />
          <h1 className="font-display text-3xl font-bold text-[#0B192C] mt-4 tracking-tight">
            Admin sign in
          </h1>
          <p className="text-sm text-[#4B5563] mt-1">
            Car Hurt Help administration
          </p>
        </div>

        <form onSubmit={onSubmit} className="mt-8 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] font-semibold text-[#4B5563] mb-1.5">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              required
              className="w-full bg-white border border-[#E2E8F0] rounded-md px-3.5 py-2.5 focus:ring-2 focus:ring-[#0B192C] focus:border-[#0B192C] focus:outline-none shadow-sm transition"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] font-semibold text-[#4B5563] mb-1.5">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              required
              className="w-full bg-white border border-[#E2E8F0] rounded-md px-3.5 py-2.5 focus:ring-2 focus:ring-[#0B192C] focus:border-[#0B192C] focus:outline-none shadow-sm transition"
              placeholder="Your password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full inline-flex justify-center items-center gap-2 rounded-md bg-[#D32F2F] hover:bg-[#B71C1C] text-white font-semibold py-3 transition-colors disabled:opacity-60"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" /> Signing in...
              </>
            ) : (
              "Sign in"
            )}
          </button>
        </form>

        <div className="mt-6 flex items-center justify-center gap-1.5 text-xs text-[#4B5563]">
          <Lock className="h-3 w-3" /> Encrypted session · Admin only
        </div>
      </div>
    </div>
  );
}
